import ReactDOM from "react-dom/client";
import App from "./app";
import { BrowserRouter } from "react-router-dom";

const container = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(container);


root.render(<BrowserRouter><App /></BrowserRouter>);
